<template>
  <div>
    <el-row :gutter="15" class="wrapper">
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待审核用户数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'users.index', query: { state_in: ['pending'] } }">
                <p class="value">{{ data.users_pending_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index'}">
                <p class="value">{{ data.orders_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">商品数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'products.index'}">
                <p class="value">{{ data.products_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">服装制单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'product_designs.index'}">
                <p class="value">{{ data.product_designs_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">草稿订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['init'] } }">
                <p class="value">{{ data.orders_init_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待销售主管审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_sales_director_audit'] } }">
                <p class="value">{{ data.orders_wait_sales_director_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待跟单员审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['pending'] } }">
                <p class="value">{{ data.orders_pending_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待总管理员审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_admin_audit'] } }">
                <p class="value">{{ data.orders_wait_admin_audit_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待BOSS审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_boss_audit'] } }">
                <p class="value">{{ data.orders_wait_boss_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待供应商BOSS确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_boss_confirm'] } }">
                <p class="value">{{ data.orders_wait_supplier_boss_confirm_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待供应商员工确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_confirm'] } }">
                <p class="value">{{ data.orders_wait_supplier_confirm_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待销售主管审核制单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'product_designs.index', query: { state_in: ['wait_sales_director_audit'] } }">
                <p class="value">{{ data.product_designs_wait_sales_director_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">送货中订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'delivering' } }">
                <p class="value">{{ data.order_delivery_delivering_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待质检订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'reached' } }">
                <p class="value">{{ data.order_delivery_reached_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待点数入库订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'checked' } }">
                <p class="value">{{ data.order_delivery_checked_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">退厂返工订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'failed' } }">
                <p class="value">{{ data.order_delivery_failed_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="section">
      <el-col :span="24">
        <ECharts :options="orderOperationLogsTrendLineOptions" style="width:100%;margin-top:10px" />
      </el-col>
    </el-row>
    <el-row class="section">
      <el-col :span="24" style="padding: 20px;">
        <h3 style="margin-bottom:20px; text-align:center;">订单数据汇总</h3>
        <el-date-picker
          v-model="supplierOrderSummaryDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleSupplierOrderSummaryDateChange"
          style="margin-bottom: 20px;"
          :clearable="false"
          :required="true"
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportSupplierOrderSummary"
          style="margin-bottom: 20px; float: right;"
        >
          导出数据
        </el-button>
        <el-table :data="supplierOrderSummary" show-summary :summary-method="getSummaries">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="padding: 0 50px;">
                <h4 style="margin-bottom: 10px;">加工厂</h4>
                <el-table :data="props.row.factories" v-if="props.row.factories && props.row.factories.length > 0">
                  <el-table-column prop="factory_name" label="加工厂名称">
                    <template slot-scope="scope">
                      {{ scope.row.factory_name }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="count" label="总款数" />
                  <el-table-column prop="on_time_count" label="按时交货数量" />
                  <el-table-column prop="in_advance_count" label="提前交货数量" />
                  <el-table-column prop="in_advance_rate" label="提前率">
                    <template slot-scope="scope">
                      {{ ((scope.row.in_advance_count / scope.row.count) * 100).toFixed(2) }}%
                    </template>
                  </el-table-column>
                  <el-table-column prop="overdue_count" label="逾期交货数" />
                  <el-table-column prop="overdue_rate" label="逾期率">
                    <template slot-scope="scope">
                      {{ ((scope.row.overdue_count / scope.row.count) * 100).toFixed(2) }}%
                    </template>
                  </el-table-column>
                </el-table>
                <p v-else style="color: #909399; padding: 20px 0;">暂无工厂数据</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="company_name" label="供应商" />
          <el-table-column prop="count" label="总款数" />
          <el-table-column prop="on_time_count" label="按时交货数量" />
          <el-table-column prop="in_advance_count" label="提前交货数量" />
          <el-table-column prop="in_advance_rate" label="提前率">
            <template slot-scope="scope">
              {{ ((scope.row.in_advance_count / scope.row.count) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column prop="overdue_count" label="逾期交货数" />
          <el-table-column prop="overdue_rate" label="逾期率">
            <template slot-scope="scope">
              {{ ((scope.row.overdue_count / scope.row.count) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

@Component({
  components: {
    ECharts
  }
})
export default class ApplicationHome extends Vue {
  data = {
    users_pending_count: 0,
    orders_count: 0,
    products_count: 0,
    product_designs_count: 0,
    orders_init_count: 0,
    orders_wait_sales_director_audit_count: 0,
    orders_pending_count: 0,
    orders_wait_boss_audit_count: 0,
    orders_wait_supplier_boss_confirm_count: 0,
    orders_wait_supplier_confirm_count: 0,
    product_designs_wait_sales_director_audit_count: 0,
    order_delivery_delivering_count: 0,
    order_delivery_reached_count: 0,
    order_delivery_checked_count: 0,
    order_delivery_failed_count: 0
  };
  supplierOrderSummary = [];
  supplierOrderSummaryDateRange = [
    new Date(new Date().setDate(1)), // 月初
    new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)) // 月末
  ];

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = '合计';
        return;
      } else if (index === 1) {
        return;
      }
      if (column.property === 'in_advance_rate' || column.property === 'overdue_rate') {
        const values = data.map(item => Number(item[column.property === 'in_advance_rate' ? 'in_advance_count' : 'overdue_count']) || 0);
        const totalCount = values.reduce((sum, value) => sum + value, 0);
        const allTotalCount = data.map(item => Number(item['count']) || 0).reduce((sum, value) => sum + value, 0);
        const average = (totalCount / allTotalCount || 0) * 100;
        sums[index] = average.toFixed(2) + '%';
      } else {
        const values = data.map(item => Number(item[column.property]) || 0);
        sums[index] = values.reduce((sum, value) => sum + value, 0);
      }
    });
    return sums;
  }

  async exportSupplierOrderSummary() {
    await this.$request.get('/dashboard/export_supplier_order_summary', {
      start_at: this.supplierOrderSummaryDateRange[0],
      end_at: this.supplierOrderSummaryDateRange[1]
    })

    this.$message.success('文件正在导出，导出成功后将会发送到邮箱')
  }

  async handleSupplierOrderSummaryDateChange(value) {
    this.supplierOrderSummaryDateRange = value
    this.fetchSupplierOrderSummary()
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/application_role')
    this.fetchSupplierOrderSummary()
  }

  async fetchSupplierOrderSummary() {
    this.supplierOrderSummary = await this.$request.get('/dashboard/supplier_order_summary', {
      start_at: this.supplierOrderSummaryDateRange[0],
      end_at: this.supplierOrderSummaryDateRange[1]
    })
  }

  get orderOperationLogsTrendLineOptions() {
    const legendData = _.map(this.data.order_operation_logs_trend, (element) => element.name)

    return _.merge({}, this.chartBaseConfig, {
      title: {
        text: '订单操作耗时（分钟）',
        left: 'center',
        textStyle: {
          fontSize: 14
        }
      },
      legend: {
        data: legendData,
        top: 50
      },
      grid: {
        top: 120
      },
      xAxis: {
        data: Object.keys(this.data.order_operation_logs_trend[0].data)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map(this.data.order_operation_logs_trend, (element) => {
        return {
          name: element.name,
          type: 'line',
          data: Object.values(element.data)
        }
      })
    })
  }
}
</script>
